import * as React from 'react';

import type {NotifyMessage} from 'nutshell-core/types';

import {RemoveButton} from '../button/remove-button/remove-button';
import {LoadingIcon} from '../icon/svg/loading-icon';

import styles from './notify-processing.module.css';

type Props = {
    notify: NotifyMessage;
    onAcknowledgeExport: (notify: NotifyMessage) => any;
};

export function NotifyProcessing(props: Props) {
    const notify = props.notify;
    const completionPercentage = notify.percentComplete;
    const completionBackground = completionPercentage
        ? {width: `${completionPercentage}%`}
        : {display: 'none'};

    const handleAcknowledgeExport = () => {
        props.onAcknowledgeExport(props.notify);
    };

    return (
        <li className={styles['notify-processing']}>
            <RemoveButton size={10} onClick={handleAcknowledgeExport} />
            <div className={styles['text-container']}>
                <span style={completionBackground} className={styles['completion-background']} />
                <span className={styles['notify-text']}>Processing {notify.type}…</span>
                <div className={styles.icon}>
                    <LoadingIcon size={15} fill='#fff' wrapWithDiv={false} />
                </div>
            </div>
        </li>
    );
}
